export function GreenStatusIcon({ small }: { small?: boolean }) {
  const width = small ? '16' : '20'
  const height = small ? '17' : '21'
  return (
    <svg width={width} height={height} viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='20' height='20' rx='10' fill='var(--green)' />
      <path
        d='M15.1933 8.13836L8.82969 14.502C8.77427 14.5576 8.70841 14.6017 8.63589 14.6319C8.56337 14.662 8.48563 14.6775 8.40711 14.6775C8.32859 14.6775 8.25084 14.662 8.17832 14.6319C8.10581 14.6017 8.03995 14.5576 7.98452 14.502L5.20043 11.7179C5.14494 11.6624 5.10092 11.5965 5.07088 11.524C5.04085 11.4515 5.02539 11.3738 5.02539 11.2953C5.02539 11.2168 5.04085 11.1391 5.07088 11.0666C5.10092 10.9941 5.14494 10.9282 5.20043 10.8727C5.25593 10.8172 5.32181 10.7732 5.39431 10.7432C5.46682 10.7132 5.54454 10.6977 5.62302 10.6977C5.7015 10.6977 5.77921 10.7132 5.85172 10.7432C5.92423 10.7732 5.99011 10.8172 6.0456 10.8727L8.4076 13.2347L14.3492 7.29418C14.4612 7.1821 14.6132 7.11914 14.7717 7.11914C14.9302 7.11914 15.0822 7.1821 15.1943 7.29418C15.3064 7.40626 15.3694 7.55827 15.3694 7.71677C15.3694 7.87527 15.3064 8.02728 15.1943 8.13935L15.1933 8.13836Z'
        fill='#010101'
      />
    </svg>
  )
}

export function RedStatusIcon({ small }: { small?: boolean }) {
  const size = small ? '18' : '20'
  return (
    <svg width={size} height={size} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1.41667' y='1.41667' width='15.1667' height='15.1667' rx='7.58333' fill='#E04D4D' />
      <rect
        x='1.41667'
        y='1.41667'
        width='15.1667'
        height='15.1667'
        rx='7.58333'
        stroke='#101013'
        strokeWidth='1.16667'
      />
      <path d='M6.75 6.75L11.25 11.25M11.25 6.75L6.75 11.25' stroke='black' strokeWidth='0.8' strokeLinecap='round' />
    </svg>
  )
}

export function OrangeStatusIcon({ small }: { small?: boolean }) {
  const size = small ? '18' : '20'
  return (
    <svg width={size} height={size} viewBox='0 0 18 18' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect x='1.41667' y='1.41667' width='15.1667' height='15.1667' rx='7.58333' fill='#E69B39' />
      <rect
        x='1.41667'
        y='1.41667'
        width='15.1667'
        height='15.1667'
        rx='7.58333'
        stroke='#101013'
        strokeWidth='1.16667'
      />
      <path
        d='M11.625 7.09169V5.79232C11.625 5.63761 11.5635 5.48923 11.4541 5.37984C11.3447 5.27044 11.1964 5.20898 11.0417 5.20898H6.95833C6.80362 5.20898 6.65525 5.27044 6.54585 5.37984C6.43646 5.48923 6.375 5.63761 6.375 5.79232V7.10482C6.3752 7.19534 6.39637 7.28459 6.43685 7.36556C6.47734 7.44653 6.53603 7.51701 6.60833 7.57148L8.51401 9.00065L6.60833 10.4298C6.53603 10.4843 6.47734 10.5548 6.43685 10.6357C6.39637 10.7167 6.3752 10.806 6.375 10.8965V12.209C6.375 12.3637 6.43646 12.5121 6.54585 12.6215C6.65525 12.7309 6.80362 12.7923 6.95833 12.7923H11.0417C11.1964 12.7923 11.3447 12.7309 11.4541 12.6215C11.5635 12.5121 11.625 12.3637 11.625 12.209V10.9096C11.6248 10.8194 11.6038 10.7305 11.5636 10.6498C11.5235 10.569 11.4653 10.4986 11.3935 10.444L9.4838 9.00065L11.3935 7.5569C11.4653 7.50243 11.5236 7.4321 11.5637 7.3514C11.6039 7.27071 11.6248 7.18183 11.625 7.09169ZM11.0417 12.209H6.95833V10.8965L9 9.36523L11.0417 10.9092V12.209ZM11.0417 7.09169L9 8.63607L6.95833 7.10482V5.79232H11.0417V7.09169Z'
        fill='black'
      />
    </svg>
  )
}

export default function StatusIcon() {
  return (
    <svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <rect y='0.5' width='20' height='20' rx='10' fill='none' fillOpacity='0.2' />
      <path
        d='M15.1933 8.13787L8.82969 14.5015C8.77427 14.5571 8.70841 14.6013 8.63589 14.6314C8.56337 14.6615 8.48563 14.677 8.40711 14.677C8.32859 14.677 8.25084 14.6615 8.17832 14.6314C8.10581 14.6013 8.03995 14.5571 7.98452 14.5015L5.20043 11.7174C5.14494 11.6619 5.10092 11.596 5.07088 11.5235C5.04085 11.451 5.02539 11.3733 5.02539 11.2948C5.02539 11.2163 5.04085 11.1386 5.07088 11.0661C5.10092 10.9936 5.14494 10.9277 5.20043 10.8722C5.25593 10.8168 5.32181 10.7727 5.39431 10.7427C5.46682 10.7127 5.54454 10.6972 5.62302 10.6972C5.7015 10.6972 5.77921 10.7127 5.85172 10.7427C5.92423 10.7727 5.99011 10.8168 6.0456 10.8722L8.4076 13.2342L14.3492 7.29369C14.4612 7.18162 14.6132 7.11865 14.7717 7.11865C14.9302 7.11865 15.0822 7.18162 15.1943 7.29369C15.3064 7.40577 15.3694 7.55778 15.3694 7.71628C15.3694 7.87478 15.3064 8.02679 15.1943 8.13886L15.1933 8.13787Z'
        fill='currentColor'
      />
    </svg>
  )
}
